document.addEventListener("turbo:load", function () {
  if (!document.getElementById("track-booking")) return;

  var radios = document.querySelectorAll(".track-booking-event-radio");
  var totalEl = document.getElementById("track-booking-total-price");
  var totalMobileEls = document.querySelectorAll(".track-booking-total-price-mobile");
  var subtotalEl = document.getElementById("track-booking-subtotal");
  var subtotalRepeatEl = document.getElementById("track-booking-subtotal-repeat");
  var multiplierRow = document.getElementById("track-booking-multiplier-row");
  var multipliedTotalEl = document.getElementById("track-booking-multiplied-total");
  var attendeeCountDisplayEl = document.getElementById("track-booking-attendee-count-display");

  var originalPriceEl = document.getElementById("track-booking-original-price");
  var superEarlyBirdRow = document.getElementById("track-booking-super-early-bird-row");
  var superEarlyBirdEl = document.getElementById("track-booking-super-early-bird-reduction");
  var earlyBirdRow = document.getElementById("track-booking-early-bird-row");
  var earlyBirdEl = document.getElementById("track-booking-early-bird-reduction");
  var groupDiscountRow = document.getElementById("track-booking-group-discount-row");
  var groupDiscountEl = document.getElementById("track-booking-group-discount-reduction");
  var multiplicationRow = document.getElementById("track-booking-multiplication-row");

  var attendeeInput = document.getElementById("tb-attendee-count");
  var attendeeLabels = document.querySelectorAll(".tb-attendee-count-label");
  var attendeeWordLabels = document.querySelectorAll(".tb-attendee-label");
  var decreaseBtn = document.getElementById("tb-decrease-attendees");
  var increaseBtn = document.getElementById("tb-increase-attendees");

  function getAttendeeCount() {
    return parseInt(attendeeInput.value, 10) || 1;
  }

  function formatPrice(num) {
    if (num === 0) return "0";
    var parts = num.toFixed(2).split(".");
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var decPart = parts[1];
    if (decPart === "00") return intPart;
    return intPart + "," + decPart;
  }

  // Fetch updated price for a single event slug + attendee count from the existing API.
  // Returns a promise resolving to { item_final_price, item_original_price, ... } as strings.
  function fetchEventPrice(priceUrl, amount) {
    var url = priceUrl + "?amount=" + amount;
    return fetch(url, { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); });
  }

  // Fetch updated prices for event radios and update their data-price attributes
  // and displayed price text. Returns a promise.
  // onlyChecked: if true, only fetch for currently checked radios (used on init)
  function refreshAllEventPrices(amount, onlyChecked) {
    var selector = onlyChecked
      ? ".track-booking-event-radio[data-price-url]:checked"
      : ".track-booking-event-radio[data-price-url]";
    var eventRadios = Array.from(document.querySelectorAll(selector));

    if (eventRadios.length === 0) return Promise.resolve();

    // Show loading indicator on total
    if (totalEl) totalEl.textContent = "…";
    totalMobileEls.forEach(function (el) { el.textContent = "…"; });

    // Deduplicate by price URL to avoid redundant requests
    var urlToRadios = {};
    eventRadios.forEach(function (radio) {
      var url = radio.getAttribute("data-price-url");
      if (!urlToRadios[url]) urlToRadios[url] = [];
      urlToRadios[url].push(radio);
    });

    var fetches = Object.keys(urlToRadios).map(function (priceUrl) {
      return fetchEventPrice(priceUrl, amount).then(function (data) {
        urlToRadios[priceUrl].forEach(function (radio) {
          var finalPrice = parseFloat(data.item_final_price) || 0;
          var originalPrice = parseFloat(data.item_original_price) || 0;

          // Update stored data attributes so updatePrices() uses fresh values
          radio.setAttribute("data-price", finalPrice.toFixed(2));
          radio.setAttribute("data-original-price", originalPrice.toFixed(2));
          radio.setAttribute("data-super-early-bird-reduction", (parseFloat(data.item_super_early_bird_reduction) || 0).toFixed(2));
          radio.setAttribute("data-early-bird-reduction", (parseFloat(data.item_early_bird_reduction) || 0).toFixed(2));
          radio.setAttribute("data-group-discount-reduction", (parseFloat(data.item_group_discount_reduction) || 0).toFixed(2));

          // Update the displayed price in the label
          var label = radio.closest("label");
          if (!label) return;

          var priceEl = label.querySelector("[data-event-price]");
          if (priceEl) priceEl.textContent = formatPrice(finalPrice) + " €";

          var strikeEl = label.querySelector("s");
          if (strikeEl) {
            if (originalPrice > finalPrice) {
              strikeEl.textContent = formatPrice(originalPrice) + " €";
              strikeEl.closest("div").style.display = "";
            } else {
              strikeEl.closest("div").style.display = "none";
            }
          }
        });
      });
    });

    return Promise.all(fetches).then(function () {
      updatePrices();
    });
  }

  function updatePrices() {
    var courseCards = document.querySelectorAll(".track-booking-course");
    var subtotal = 0;
    var originalSubtotal = 0;
    var totalSuperEarlyBird = 0;
    var totalEarlyBird = 0;
    var totalGroupDiscount = 0;
    var attendees = getAttendeeCount();

    courseCards.forEach(function (card) {
      var courseId = card.getAttribute("data-course-id");
      var checked = card.querySelector("input[type='radio']:checked");
      var summaryRow = document.querySelector('.track-booking-summary-row[data-course-id="' + courseId + '"]');
      var summaryPrice = summaryRow ? summaryRow.querySelector(".track-booking-summary-price") : null;
      var summaryStatus = summaryRow ? summaryRow.querySelector(".track-booking-summary-status") : null;

      if (checked) {
        var price = parseFloat(checked.getAttribute("data-price")) || 0;
        var value = checked.value;

        if (value === "skip") {
          if (summaryPrice) summaryPrice.textContent = "--";
          if (summaryStatus) summaryStatus.textContent = "Übersprungen";
        } else if (value === "later") {
          if (summaryPrice) summaryPrice.textContent = "TBD";
          if (summaryStatus) summaryStatus.textContent = "Termin wird noch gewählt";
        } else {
          subtotal += price;
          var seb = parseFloat(checked.getAttribute("data-super-early-bird-reduction")) || 0;
          var eb = parseFloat(checked.getAttribute("data-early-bird-reduction")) || 0;
          var gd = parseFloat(checked.getAttribute("data-group-discount-reduction")) || 0;
          originalSubtotal += price + seb + eb + gd;
          totalSuperEarlyBird += seb;
          totalEarlyBird += eb;
          totalGroupDiscount += gd;
          var formatted = formatPrice(price) + " €";
          if (summaryPrice) summaryPrice.textContent = formatted;
          var label = checked.closest("label");
          if (label && summaryStatus) {
            var dateEl = label.querySelector("[data-event-date]");
            var locEl = label.querySelector("[data-event-location]");
            var statusText = "";
            if (dateEl) statusText = dateEl.textContent.trim();
            if (locEl) statusText += " · " + locEl.textContent.trim();
            summaryStatus.textContent = statusText;
          }
        }
      } else {
        if (summaryPrice) summaryPrice.textContent = "--";
        if (summaryStatus) summaryStatus.textContent = "Noch kein Termin gewählt";
      }
    });

    var total = subtotal * attendees;
    var formattedSubtotal = formatPrice(subtotal);
    var formattedTotal = formatPrice(total);

    // Original (pre-discount) price
    if (originalPriceEl) originalPriceEl.textContent = formatPrice(originalSubtotal);

    // Discount rows (per-person amounts)
    if (superEarlyBirdRow) superEarlyBirdRow.style.display = totalSuperEarlyBird > 0 ? "" : "none";
    if (superEarlyBirdEl) superEarlyBirdEl.textContent = formatPrice(totalSuperEarlyBird);
    if (earlyBirdRow) earlyBirdRow.style.display = totalEarlyBird > 0 ? "" : "none";
    if (earlyBirdEl) earlyBirdEl.textContent = formatPrice(totalEarlyBird);
    if (groupDiscountRow) groupDiscountRow.style.display = totalGroupDiscount > 0 ? "" : "none";
    if (groupDiscountEl) groupDiscountEl.textContent = formatPrice(totalGroupDiscount);

    var hasDiscounts = totalSuperEarlyBird > 0 || totalEarlyBird > 0 || totalGroupDiscount > 0;

    if (attendees > 1) {
      // Show "Preis pro Person" row only when there are discounts (otherwise subtotal is enough)
      if (multiplierRow) multiplierRow.style.display = hasDiscounts ? "" : "none";
      if (multiplicationRow) multiplicationRow.style.display = "";
      if (subtotalEl) subtotalEl.textContent = formattedSubtotal;
      if (subtotalRepeatEl) subtotalRepeatEl.textContent = formattedSubtotal;
      if (attendeeCountDisplayEl) attendeeCountDisplayEl.textContent = attendees;
      if (multipliedTotalEl) multipliedTotalEl.textContent = formattedTotal;
    } else {
      if (multiplierRow) multiplierRow.style.display = "none";
      if (multiplicationRow) multiplicationRow.style.display = "none";
      if (subtotalEl) subtotalEl.textContent = formattedSubtotal;
    }

    if (totalEl) totalEl.textContent = formattedTotal;
    totalMobileEls.forEach(function (el) { el.textContent = formattedTotal; });
  }

  function updateCardHeader(card, checked) {
    var courseId = card.getAttribute("data-course-id");
    var selectedSummary = card.querySelector('.track-booking-selected-summary[data-course-id="' + courseId + '"]');
    var summaryText = selectedSummary ? selectedSummary.querySelector(".track-booking-selected-summary-text") : null;

    if (!checked || checked.value === "skip") {
      if (selectedSummary) selectedSummary.style.display = "none";
      return;
    }

    var label = checked.closest("label");
    var text = "";
    if (checked.value === "later") {
      text = "Termin wird noch gewählt";
    } else if (label) {
      var dateEl = label.querySelector("[data-event-date]");
      var locEl = label.querySelector("[data-event-location]");
      if (dateEl) text = dateEl.textContent.trim();
      if (locEl) text += " · " + locEl.textContent.trim();
    }

    if (selectedSummary && summaryText) {
      summaryText.textContent = text;
      selectedSummary.style.display = "";
    }
  }

  function syncSelectionsToUrl() {
    var params = new URLSearchParams(window.location.search);
    Array.from(params.keys())
      .filter(function (k) { return k.startsWith("s_"); })
      .forEach(function (k) { params.delete(k); });

    document.querySelectorAll(".track-booking-course").forEach(function (card) {
      var courseId = card.getAttribute("data-course-id");
      var checked = card.querySelector("input[type='radio']:checked");
      if (checked && checked.value !== "skip") {
        params.set("s_" + courseId, checked.value);
      }
    });

    var attendees = getAttendeeCount();
    if (attendees > 1) { params.set("attendees", attendees); } else { params.delete("attendees"); }

    var qs = params.toString();
    history.replaceState(null, "", window.location.pathname + (qs ? "?" + qs : ""));
  }

  // Wire up radio buttons
  radios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      var priceUrl = this.getAttribute("data-price-url");
      if (priceUrl) {
        // Fetch fresh price for this event to get discount breakdown, then update
        refreshAllEventPrices(getAttendeeCount(), true);
      } else {
        updatePrices();
      }
      syncSelectionsToUrl();

      var collapseTarget = this.getAttribute("data-collapse-target");
      if (collapseTarget) {
        var collapseEl = document.getElementById(collapseTarget);
        if (collapseEl && collapseEl.classList.contains("show")) {
          var bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseEl);
          setTimeout(function () { bsCollapse.hide(); }, 200);
        }
      }

      var card = this.closest(".track-booking-course");
      if (card) updateCardHeader(card, this);
    });
  });

  // Chevron rotation on collapse
  document.querySelectorAll(".track-booking-course").forEach(function (card) {
    var collapseEl = card.querySelector(".collapse");
    var chevron = card.querySelector(".track-booking-chevron");
    if (!collapseEl || !chevron) return;

    collapseEl.addEventListener("show.bs.collapse", function () {
      chevron.style.transform = "rotate(0deg)";
    });
    collapseEl.addEventListener("hide.bs.collapse", function () {
      chevron.style.transform = "rotate(-90deg)";
    });
  });

  // Attendee stepper — refetch prices on count change
  function setAttendeeCount(count) {
    attendeeInput.value = count;
    attendeeLabels.forEach(function (el) { el.textContent = count; });
    // Both forms come from the server so they follow the request locale.
    attendeeWordLabels.forEach(function (el) {
      var label = count === 1 ? el.dataset.labelSingular : el.dataset.labelPlural;
      if (label) el.textContent = label;
    });
    syncSelectionsToUrl();
    refreshAllEventPrices(count);
  }

  if (decreaseBtn) {
    decreaseBtn.addEventListener("click", function () {
      var count = getAttendeeCount();
      if (count > 1) setAttendeeCount(count - 1);
    });
  }

  if (increaseBtn) {
    increaseBtn.addEventListener("click", function () {
      var count = getAttendeeCount();
      var max = parseInt(attendeeInput.getAttribute("max"), 10) || 10;
      if (count < max) setAttendeeCount(count + 1);
    });
  }

  // Init: update card headers and prices based on server-rendered checked state
  document.querySelectorAll(".track-booking-course").forEach(function (card) {
    var checked = card.querySelector("input[type='radio']:checked");
    if (checked) updateCardHeader(card, checked);
  });

  // Fetch prices for checked events on load to populate discount breakdown
  refreshAllEventPrices(getAttendeeCount(), true);
});
